import React, { useState, useEffect } from 'react';
import MobileMenu from './MobileMenu';
import DesktopMenu from './DesktopMenu';
import './Navigation.css';

const Navigation = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    return (
        <nav className="navbar">
            {isMobile ? <MobileMenu /> : <DesktopMenu />}
        </nav>
    );
};

export default Navigation; 